// Top-level widget sync.
// Fetches today's habits + logs for the current user and pushes a snapshot
// to the native iOS widget — regardless of which page the user opened the
// app to. Includes a daily quote so the iOS widget can render either a
// "habits" or "quote" layout per the user's preference.
import { supabase } from './supabase';
import { isScheduledOn, todayISO } from './dates';
import { quoteForDay } from './quotes';
import { updateWidgetSnapshot } from './widget';

export async function pushWidgetForUser(userId, opts = {}) {
  if (!userId) return;
  try {
    const date = todayISO();

    // Load the widget_style preference from profile if not provided.
    let style = opts.style;
    if (!style) {
      const { data: profile } = await supabase
        .from('profiles')
        .select('widget_style')
        .eq('id', userId)
        .maybeSingle();
      style = profile?.widget_style || 'habits';
    }

    const [{ data: habits }, { data: logs }] = await Promise.all([
      supabase
        .from('habits')
        .select('*')
        .is('archived_at', null)
        .order('sort_order')
        .order('created_at'),
      supabase
        .from('habit_logs')
        .select('*')
        .eq('log_date', date),
    ]);

    const scheduled = (habits || []).filter((h) => isScheduledOn(h, new Date()));
    const logsByHabit = {};
    (logs || []).forEach((l) => { logsByHabit[l.habit_id] = l; });

    const items = scheduled.slice(0, 10).map((h) => {
      const l = logsByHabit[h.id];
      const completed = l
        ? (h.type === 'binary'
            ? l.status === 'done'
            : Number(l.value || 0) >= Number(h.target_value || 1))
        : false;
      return {
        id: h.id,
        name: h.name,
        icon: h.icon,
        color: h.color,
        time_of_day: h.time_of_day,
        completed,
      };
    });
    const doneCount = items.filter((x) => x.completed).length;
    const q = quoteForDay(new Date());

    await updateWidgetSnapshot({
      updatedAt: new Date().toISOString(),
      dateISO: date,
      loggedOut: false,
      style,
      done: doneCount,
      total: items.length,
      items,
      quote: q.text,
      quoteAuthor: q.author,
    });
  } catch (err) {
    console.warn('[mfh] widget sync failed:', err);
  }
}
